<template>
  <div class="pa-1">
    <v-form v-model="valid" class="white pa-4" style="border-radius: 15px">
      <block v-if="loading"></block>

      <v-row class="ml-2 mr-2">
        <v-col cols="12" md="12" class="tabsNh">
          <v-col cols="12" class="d-flex justify-space-between" style="min-height: 50px">
            <div>
              <v-btn small color="error" @click.prevent.stop="confirmdeleteProduct()">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </div>

            <div>
              <v-btn
                 small class="btn-save" @click.prevent.stop="updateProducts">
                <v-icon>mdi-content-save</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-col>

        <v-col cols="12" md="12" style="display: flex; justify-content: space-between; margin-top: 1rem">
          <h2>Información General</h2>

          <div style="display: none">
            <v-checkbox v-model="form.isglobalbranch" label="Mostrar en todas las sucursales"></v-checkbox>
          </div>
        </v-col>

        <v-col cols="12" md="12" style="display: flex; justify-content: space-between; margin: 1rem 0">
          <h4>ID del Producto: {{ form.iditem }}</h4>
        </v-col>

        <v-col cols="12" md="3" sm="8" style="margin-top: 0.8rem">
          <div style="justify-content: center; display: flex; width: 50%; margin-left: 25%">
            <v-img :src="url" class="preview-avatar" @click="handleClickImage"/>
          </div>
          <v-file-input style="width: 80%; margin-left: 10%" @change="Preview_image" v-model="image"
            label="Seleccione imágen del articulo" prepend-icon="mdi-camera" placeholder="Seleccione imágen del articulo" :rules="[maxFileSize]">
          </v-file-input>
        </v-col>

        <v-col cols="12" md="3">
          <!--     <v-select outlined dense  :items="types" label="Tipo de Articulo*" v-model="form.itemtype" required
              :rules="requiredRule"></v-select> -->
          <v-text-field outlined dense v-model="form.itemname" label="Nombre del Articulo*" required
            :rules="[(v) => !!v || 'El nombre del articulo es requerido']" @input="fillItemComercialName"></v-text-field>
          <v-autocomplete outlined dense :items="unidades" item-value="Valores" item-text="Valores" attach label="Medida de Unidad"
            v-model="form.itemmeasureunit"></v-autocomplete>
          <v-autocomplete outlined dense attach :items="tipoItemCompraGasto" item-value="Codigo" item-text="Valores"
            label="Producto declarable como:" v-model="form.itemdeclarationtype"></v-autocomplete>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field outlined dense v-model="form.itemprice" label="Precio" type="number" prefix="$" required
            :rules="[(v) => !!v || 'El precio del articulo es requerido']"></v-text-field>
          <!--v-select outlined dense  :items="providers" item-text="ProviderName" item-value="ID_Provider" label="Provedor*" attach
              v-model="form.idprovider" required :rules="requiredRule"></v-select-->
          <!-- <v-text-field outlined dense v-model="form.itembarcode" label="Código de Barra del Articulo" required
              maxlength="100"></v-text-field> -->
          <v-text-field outlined dense v-model="form.suggestedprice" label="Precio sugerido*" type="number" prefix="$"
            required :rules="[(v) => !!v || 'El precio sugerido del articulo es requerido']"></v-text-field>
          <v-text-field outlined dense v-model="form.maxdiscountpercentage" 
              label="% Desc. Máx." type="number" suffix="%" 
              @input="syncDiscountDecimal"
              :hint="discountPreviewHint"
              persistent-hint
              :rules="[(v) => !v || (v >= 0 && v <= 100) || 'Debe ser entre 0 y 100']"></v-text-field>
        </v-col>

          <v-col cols="12" md="3">
            <v-text-field outlined dense v-model="form.itemcomercialname" label="Nombre Comercial del Articulo"></v-text-field>
              <v-text-field outlined dense v-model="form.itemdescription" label="Descripción del Articulo" maxlength="250"></v-text-field>
              <v-text-field outlined dense v-model="form.maxsalepercentage" 
                label="% Venta Máx." type="number" suffix="%" 
                @input="syncSaleDecimal"
                :hint="salePreviewHint"
                persistent-hint
                :rules="[(v) => !v || (v >= 0 && v <= 100) || 'Debe ser entre 0 y 100']"></v-text-field>
                <v-text-field outlined dense v-model="form.profitpercentage"
                label="% Ganancia general" type="number" suffix="%"
                :rules="[(v) => v === null || v === '' || (v >= 0 && v <= 10000) || 'Debe ser entre 0 y 10000']" />
          </v-col>

          <v-col cols="12" md="3" class="product-action-row">
          </v-col>

          <v-col cols="12" md="3" class="product-action-row">
            <v-btn class="btnadd mb-5" @click="dialogBarCode = true">Gestión de códigos de barra /<br>códigos alternos</v-btn>
          </v-col>

          <v-col cols="12" md="3" class="product-action-row">
            <v-btn class="btnadd mb-5" @click.prevent.stop="openPriceListMarginsDialog">
              Margen de ganancias por listas de <br> precios
            </v-btn>
          </v-col>

          <v-col cols="12" md="3" class="product-action-row">
          </v-col>

        <v-col cols="12"  class="mt-2 mb-4 p-2">
          <v-card class="pa-4">
            <v-row no-gutters>
               <v-col cols="12 mb-2">
                <b>Segmentaciones</b>
              </v-col>
              <v-col cols="12" sm="4" md="3" lg="3" xl="3" class="pa-2">
          <!--   <v-select outlined dense  :items="families" item-text="name" item-value="id" label="Familia" v-model="form.family" attach
                      required></v-select> -->
                <v-autocomplete outlined dense label="Familia " v-model="form.family" 
                    @change="() => {
                      removeSon();
                      getCategoriesByFamily();
                    }"
                    :items="families" item-text="name" attach
                      item-value="id"></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="4" md="3" lg="3" xl="3" class="pa-2">
                  <!-- <v-select outlined dense  :items="categories" item-text="name" item-value="id" label="Categoria" v-model="form.category" attach
                              required></v-select> -->
                <v-autocomplete outlined dense label="Categoría" 
                  @change="() => {
                    form.subcategory = null;
                    getSubsByCategory();
                  }"
                  v-model="form.category" :items="filteredCategories" 
                    item-text="name" attach item-value="id" :disabled="!form.family"></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="4" md="3" lg="3" xl="3" class="pa-2">
          <!--  <v-select outlined dense  :items="subcategories" item-text="name" item-value="id" label="Sub Categoria" v-model="subcategory" attach
                    required></v-select> -->
                <v-autocomplete outlined dense label="Subcategoría" v-model="form.subcategory" :items="filteredSubcategories"
                  attach item-text="name" item-value="id" :disabled="!form.category"></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="4" md="3" lg="3" xl="3" class="pa-2">
                <v-autocomplete 
                  outlined 
                  dense 
                  label="Marca" 
                  v-model="form.items_brand" 
                  :items="brands" 
                  item-text="brand" 
                  attach
                  item-value="id">
                </v-autocomplete>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <v-col cols="12" class="mb-4">
          <v-card class="pa-4 pt-4">
            <v-row no-gutters>
              <v-col cols="12" class="mb-2">
                <b>
                  Configuraciones
                </b>
              </v-col>
              <v-col cols="12">
                <div class="d-flex flex-row flex-wrap align-start justify-start">
                  <v-checkbox v-model="form.no_provider" label="Agregar proveedor despues" class="mr-4 mb-2"/>
                  <v-checkbox v-model="form.ishidrocarburo" label="Producto es hidrocarburo" class="mr-4"></v-checkbox>
                  <v-checkbox v-model="form.isexempt" label="Producto exento" class="mr-4" @change="handleTaxFlagChange('isexempt')"></v-checkbox>
                  <v-checkbox v-model="form.isnosujeto" label="Producto no sujeto" class="mr-4" @change="handleTaxFlagChange('isnosujeto')"></v-checkbox>
                  <v-checkbox v-model="form.isnoafecto" label="Producto no gravado" class="mr-4" @change="handleTaxFlagChange('isnoafecto')"></v-checkbox>
                  <v-checkbox v-if="posrestaurant" v-model="form.bloquearpropinas" label="No aplicar propina" class="mr-4"></v-checkbox>
                  <v-checkbox v-if="ishosting" v-model="form.turismoporalojamiento" label="Aplicar impuesto de turismo por alojamiento"></v-checkbox>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
         <v-col cols="12" class="mb-4">
          <v-card class="pa-4 pt-4">
            <v-row no-gutters>
              <v-col cols="12" class="mb-2">
                <b>
                  Gestiones
                </b>
              </v-col>
              <v-col cols="12">
                <div class="d-flex flex-row flex-wrap align-start justify-start">
                  <v-btn class="btnadd mr-4 mb-2" @click.prevent.stop="dialog = true">
                  Gestionar segmentación
                  </v-btn>
                  <v-btn class="btnadd mr-4 mb-2" @click.prevent.stop="dialogBrand = true">
                  Gestionar marcas
                  </v-btn>
                  <v-btn  color="primary" class="mr-4 mb-2" dark @click="dialogProviders = true">Gestión de proveedores</v-btn>
                  <v-btn color="primary" class="mr-4 mb-2" dark @click="openPriceListEditor">
                    Editar lista de precios
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <!-- <v-col cols="12" md="4" lg="4" class="mt-7">
          <v-autocomplete outlined dense :items="warehouses" item-text="Warehouse" item-value="ID_Warehouse"
            label="Almacén" attach v-model="form.warehouse" @change="fillBatchsAndAccountingGroups()">
          </v-autocomplete>
        </v-col> -->
        <!-- <v-col cols="12" md="12">
          <h3>Cuenta Contable</h3>
          <br />
        </v-col>
        <v-col cols="12" md="2" class="mb-7">
          <v-btn class="btn-save" @click.prevent.stop="">
          <v-btn class="btn-save" @click.prevent.stop="showAccountsModal = true" >Buscar Cuenta
            
          </v-btn>
        </v-col>
        <v-col cols="12" md="2">
          <v-autocomplete outlined dense  label="Código de Cuenta Contable" v-model="form.id_account" :items="accountList" attach
            item-text="account_code" item-value="id_account"></v-autocomplete>
        </v-col>
        <v-col cols="12" md="8">
          <v-autocomplete outlined dense  label="Nombre de Cuenta Contable" v-model="form.id_account" :items="accountList" attach
            item-text="account_description" item-value="id_account" :disabled="!form.category"></v-autocomplete>
        </v-col>

        <v-dialog v-model="showAccountsModal" width="60%">
          <v-card>
            <AccountingItemForm :win="win"
              v-on:sendSelection="accountSelectionHandler"
            />
          </v-card>
        </v-dialog> -->
        <v-col cols="12" class="mb-6">
          <v-card class="pa-6">
            <v-card-title class="subtitle-1 font-weight-bold">
              Asignación de Cuentas Contables
            </v-card-title>
            <v-row
              v-for="item in accounts"
              :key="item.model"
              align="center"
              class="mb-4"
            >
              <v-col cols="12" md="4">
                {{ item.label }}
              </v-col>
              <v-col cols="12" md="7">
                <v-text-field
                  :value="getAccountDetail(form[item.model])"
                  readonly
                  dense
                  outlined
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="1" class="text-md-right">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      @click="setEditCatalog(item.model)"
                    >
                      <v-icon>mdi-magnify</v-icon>
                    </v-btn>
                  </template>
                  <span>Seleccionar cuenta contable</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="mx-2">
        <!--v-col cols="12" md="6" lg="4">
                              <v-select outlined dense  :disabled="!batchs.length" :items="batchs" item-text="ID_ItemBatch" attach
                                  item-value="ID_ItemBatch" v-model="form.itemlote" label="Lote"></v-select>
                          </v-col-->

        <!--v-col cols="12" md="6" lg="4">
                              <v-select outlined dense  :disabled="!accountinggroups.length" :items="accountinggroups"
                                  label="Grupo de Productos" hint="Familía de Productos / Categoría / Subcategoría"
                                  persistent-hint return-object @change="setValInForm()" v-model="selectaccountinggroup">
                                  <template slot="item" slot-scope="data">
                                      {{ data.item.AccountingLineName }} / {{ data.item.AccountingCategoryName }} / {{
                                              data.item.AccountingSubCategoryName
                                      }}
                                  </template>
                                  <template slot="selection" slot-scope="data">
                                      {{ data.item.AccountingLineName }} / {{ data.item.AccountingCategoryName }} / {{
                                              data.item.AccountingSubCategoryName
                                      }}
                                  </template>

                              </v-select>
                          </v-col-->

        <v-col cols="12" md="4" style="display: none !important">
          <v-text-field outlined dense v-model="form.itemconversionfactor" label="Factor de Conversión"
            maxlength="20"></v-text-field>
        </v-col>
        <v-col cols="12" md="2" style="display: none !important">
          <v-text-field outlined dense v-model="form.unitspackaging" type="number" label="Unidades Packaging"
            maxlength="20"></v-text-field>
        </v-col>
        <v-col cols="12" md="2" style="display: none !important">
          <v-autocomplete outlined dense v-model="typepack" label="Unidad" attach :items="unidades" item-value="Valores" item-text="Valores"></v-autocomplete>
        </v-col>
        <v-col cols="12" md="2" style="display: none !important">
          <v-autocomplete outlined dense v-model="typepack" label="Unidad" attach :items="unidades" item-value="Valores" item-text="Valores"></v-autocomplete>
        </v-col>
        <v-col cols="12" md="6">
          <h3 style="text-align: center" class="tabs" @click.prevent.stop="showItemStructure = !showItemStructure">
            Gestión de estructuración de producto
          </h3>
          <v-dialog v-model="showItemStructure" max-width="60%" scrollable>
            <v-card>
              <v-card-title>
                <h3>Gestión de estructuración del producto</h3>
              </v-card-title>
              <v-card-text>
                <GeneralFilter v-model="filterProducts" :filterEndpoint="$API.products.newGetProducts" 
                  :search="{filter: filterProducts }"
                  @emptyFilter="getProducts" @filtered="filterHandlerProducts">
                  <DxDataGrid :data-source="dataProducts" :scrolling="{ useNative: true }">
                    <DxPaging :page-size="5" />
                    <DxColumn :width="50" cell-template="add-product" caption=""></DxColumn>
                    <template #add-product="{ data }">
                      <a href="#" @click="addProductToStructure(data.data)">
                        <v-icon>mdi-plus</v-icon>
                      </a>
                    </template>
                    <DxColumn data-field="ID_Item" caption="ID de Producto"></DxColumn>
                    <DxColumn data-field="ItemName" caption="Nombre de Producto"></DxColumn>
                    <DxColumn data-field="ItemComercialName" caption="Nombre Comercial"></DxColumn>
                  </DxDataGrid>
                </GeneralFilter>

                <h4>Estructuración actual del producto:</h4>
                <DxDataGrid :data-source="dataProductsStructure" :scrolling="{ useNative: true }">
                  <DxPaging :page-size="5" />
                  <DxEditing
                    :allow-updating="true"
                    :select-text-on-edit-start="true"
                    start-edit-action="click"
                    mode="cell"
                  />
                  <DxColumn caption="ID de Producto" data-field="ID_Item_Base" :allow-editing="false"></DxColumn>
                  <DxColumn caption="Nombre de Producto" data-field="ItemName" :allow-editing="false"></DxColumn>
                  <DxColumn caption="Nombre Comercial" data-field="ItemComercialName" :allow-editing="false"></DxColumn>
                  <DxColumn caption="Cantidad base" data-field="QuantityBase" data-type="number" :allow-editing="true"></DxColumn>
                  <DxColumn :width="145" caption="Unidad" cell-template="select-unit" data-field="UnitBase" :allow-editing="false"></DxColumn>
                  <template #select-unit="{ data }">
                    <span>
                    <select
                      class="form-control custom-select"
                      v-model="data.data.UnitBase"
                    >
                      <option
                        v-for="unidad in unidades"
                        :value="unidad.Valores"
                        :key="unidad.Valores"
                      >
                        {{ unidad.Valores }}
                      </option>
                    </select>
                  </span>
                  </template>
                  <DxColumn :width="50" cell-template="del-product" caption=""></DxColumn>
                  <template #del-product="{ data }">
                    <a href="#" @click="delProductOfStructure(data.data)">
                      <v-icon>mdi-delete</v-icon>
                    </a>
                  </template>
                </DxDataGrid>
              </v-card-text>
              <v-card-actions>
                <v-btn @click="saveStructureOfProduct()" class="btncontinue">
                  Cerrar
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn @click="saveStructureOfProduct()" class="btn-save" >
                  <v-icon>mdi-content-save</v-icon>
                   Guardar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
        <v-col cols="12" md="6">
          <h3 style="text-align: center" :class="showBgcolorNotes" @click.prevent="showNotes = !showNotes">
            Comentarios
          </h3>
          <v-dialog v-model="showNotes" width="60%">
            <v-card class="pa-4">
              <div style="
                  margin-top: 0.3rem;
                  margin-bottom: 0.3rem;
                  display: flex;
                  justify-content: flex-end;
                ">
                <v-btn small class="btndelete" @click.prevent="showNotes = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
              <quill-editor v-show="showNotes" :options="quillOptions" :content="form.itemnote"
                @change="onEditorChange($event)"></quill-editor>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-form>

    <v-dialog v-model="showCatalogo" width="60%">
      <v-card>
        <AccountingItemForm :win="win"
        v-on:sendSelection="setAccountingSelected"
        :isAllowTransaction="isAllowTransaction"
        :PropSearch="propSearchReset"
        />
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog" max-width="60%" height="100%">
      <ManageCategory :win="win" v-on:reloadCategories="reloadCategories" />
    </v-dialog>
    <v-dialog v-model="dialogProviders" max-width="60%">
      <v-card>
        <v-card-title>
          <h2>Asignación de proveedores</h2>
        </v-card-title>
        <v-card-text>
          <h4>Seleccione los proveedores asociados a este producto.</h4>
          <GeneralFilter :hideLimitLabel="true" :filterEndpoint="filterPromise" :search="{}" @emptyFilter="clearFilter"
            @filtered="filterHandler">
            <DxDataGrid class="isScrolledByGeneralFilter" :show-borders="true"
              :data-source="isFiltered ? providersFiltered : providers">
              <DxPaging :page-size="5" />
              <DxColumn :width="70" cell-template="select-provider" caption=""></DxColumn>
              <DxColumn data-field="ProviderName" caption="Proveedor"></DxColumn>
              <DxColumn data-field="ProviderPhone" caption="Télefono"></DxColumn>
              <DxColumn data-field="ProviderEmail" caption="Correo"></DxColumn>
              <DxColumn data-field="ProviderAddress" caption="Dirección"></DxColumn>

              <template #select-provider="{ data }">
                <div>
                  <v-checkbox v-model="data.data.Checked" @click="testFunction" />
                  <!-- <v-checkbox v-model="data.data.Checked" /> -->
                </div>
              </template>
            </DxDataGrid>
          </GeneralFilter>
        </v-card-text>
        <v-card-actions>
          <v-col class="text-right">
            <v-btn right class="btncontinue" @click="dialogProviders = false">Continuar</v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogPriceListMargins" max-width="72%">
      <v-card class="price-list-margins-dialog">
        <v-card-title class="d-flex justify-space-between align-center">
          <h2>Márgenes por lista de precios</h2>
          <v-btn icon @click="dialogPriceListMargins = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-subtitle>
          {{ form.iditem }} - {{ form.itemname }}
        </v-card-subtitle>
        <v-card-text class="price-list-margins-content">
          <block v-if="loadingPriceListMargins"></block>
          <div v-else>
            <div class="price-list-margins-toolbar">
              <v-text-field
                v-model="searchPriceListMargins"
                class="price-list-margins-search"
                outlined
                dense
                hide-details
                label="Buscar lista de precios"
                prepend-inner-icon="mdi-magnify"
              />
              <span class="caption grey--text text--darken-1 price-list-margins-hint">
                {{ savingPriceListMargins ? 'Sincronizando cambios...' : 'Los cambios se guardan automáticamente' }}
              </span>
            </div>

            <div class="price-list-margins-section">
              <h4 class="mb-2">Listas disponibles</h4>
              <DxDataGrid
                class="price-list-margins-grid"
                :data-source="availablePriceLists"
                :show-borders="true"
                :column-auto-width="true"
                :row-alternation-enabled="true"
                :hover-state-enabled="true"
                no-data-text="No hay listas disponibles para agregar."
              >
                <DxPaging :page-size="5" />
                <DxColumn :width="70" cell-template="add-margin-row" caption=""></DxColumn>
                <DxColumn data-field="PriceListName" caption="Lista de precios"></DxColumn>
                <template #add-margin-row="{ data }">
                  <div class="text-center">
                    <v-btn icon color="primary" @click="addPriceListMargin(data.data)">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </div>
                </template>
              </DxDataGrid>
            </div>

            <div class="price-list-margins-section mt-5">
              <h4 class="mb-2">Márgenes en edición</h4>
              <DxDataGrid
                class="price-list-margins-grid"
                :data-source="selectedPriceLists"
                :show-borders="true"
                :column-auto-width="true"
                :row-alternation-enabled="true"
                :hover-state-enabled="true"
                no-data-text="No has agregado listas para configurar margen."
              >
                <DxPaging :page-size="5" />
                <DxColumn data-field="PriceListName" caption="Lista de precios"></DxColumn>
                <DxColumn :width="220" cell-template="margin-template" caption="% Margen"></DxColumn>
                <DxColumn :width="90" cell-template="remove-margin-row" caption=""></DxColumn>
                <template #remove-margin-row="{ data }">
                  <div class="text-center">
                    <v-btn icon color="error" @click="removePriceListMargin(data.data)">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </template>
                <template #margin-template="{ data }">
                  <div class="margin-editor">
                    <input
                      :value="data.data.ProfitMarginPercentage"
                      type="number"
                      min="0"
                      step="0.0001"
                      class="margin-editor__input"
                      @click="selectAllText($event)"
                      @input="onPriceListMarginInput(data.data, $event.target.value)"
                      @blur="persistPriceListMargins()"
                    />
                    <span class="margin-editor__suffix">%</span>
                  </div>
                </template>
              </DxDataGrid>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btncontinue" @click="dialogPriceListMargins = false">
            Cerrar
          </v-btn>
          <v-btn class="btnsave" :disabled="loadingPriceListMargins || savingPriceListMargins" @click="persistPriceListMargins(false, true)">
            <v-icon>mdi-content-save</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Add barcode -->
    <v-dialog v-model="dialogBarCode" class="barcode-dialog .border-boxGlobal" max-width="40%">
      <v-card>
      <block v-if="loadingBarCode"/>
        <v-card-title>
          <h2 class="mx-3">Asignación de código de barra / código alterno</h2>
          <span class="mx-3 width-100 note-size"><b>Nota:</b> Los códigos de barras se actualizan, crean y eliminan al realizar la acción</span>
        </v-card-title>
        <v-card-text>
          <!-- <h4>Seleccione los proveedores asociados a este producto.</h4> -->
          <v-row class="mt-3">
            <v-col cols="12" class="d-flex justify-center mx-3">
              <v-text-field outlined dense v-model="barCodeToAdd" @keyup.enter="addBarCode" label="Código de barra / código alterno*"
                :rules="[(v) => !!v || 'El código de barra / código alterno requerido'] " required></v-text-field>
              <v-btn class="btn-save ml-5 mx-8" @click="addBarCode"><v-icon class="mr-3">mdi-barcode-scan</v-icon> Agregar código</v-btn>
            </v-col>
          </v-row>
          <GeneralFilter :hideLimitLabel="true" :filterEndpoint="$API.inventoryitemsbarcodes.getAllBarCodesFiltered"
            :search="search" @emptyFilter="getAllBarCodesHistory" @filtered="filterHandlerBarCodes">
            <DxDataGrid class="isScrolledByGeneralFilter grid-max-width" :show-borders="true" :data-source="barCodes">
              <DxPaging :page-size="5" />
              <DxColumn :width="70" cell-template="edit-barcode"></DxColumn>
              <DxColumn data-field="BarCode" caption="Código de barra / código alterno"></DxColumn>
              <DxColumn :width="70" cell-template="check-principal" caption="Principal"></DxColumn>
              <template #check-principal="{ data } ">
                <div>
                  <center><v-checkbox v-model="data.data.PrincipalBarCode" @change="checkPrincipalBarCode(data.data)"></v-checkbox></center>
                </div>
              </template> 
              <DxColumn :width="70" cell-template="delete-barcode"> </DxColumn>
              <template #edit-barcode="{ data }">
                <div>
                  <a class="mx-1" @click="editShowBarCode(data.data)">
                    <v-icon color="primary">mdi-eye</v-icon>
                  </a>
                </div>
              </template>
              <template #delete-barcode="{ data }">
                <div>
                  <a class="mx-1" @click="deleteBarCode(data.data)">
                    <v-icon color="error">mdi-delete</v-icon>
                  </a>
                </div>
              </template>
            </DxDataGrid>
          </GeneralFilter>
        </v-card-text>
        <v-card-actions>
          <v-col class="text-right">
            <v-btn right class="btncontinue" @click="dialogBarCode = false">Continuar</v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Add barcode -->

    <!-- Edit barcode -->
    <v-dialog v-model="dialogEditBarCode" class="barcode-edit-dialog .border-boxGlobal" max-width="40%">
      <v-card>
        <v-card-title>
          <h2>Editar de código de barra - {{ previousCode }}</h2>
        </v-card-title>
        <v-card-text>
          <!-- <h4>Seleccione los proveedores asociados a este producto.</h4> -->
          <v-row class="mt-3">
            <v-col cols="12" class="d-flex justify-center">
              <v-text-field @keyup.enter="editBarCode" outlined dense v-model="barCodeToEdit" label="Código de barra / código alterno*"
                :rules="[(v) => !!v || 'El código de barra / código alterno es requerido']" required></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-col cols="12" class="d-flex justify-space-between">
            <v-btn class="btn-save ml-5" @click="editBarCode">Editar</v-btn>
            <v-btn right class="btncontinue" @click="dialogEditBarCode = false">Continuar</v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Edit barcode -->

    <v-dialog v-model="dialogBrand" scrollable class="barcode-edit-dialog .border-boxGlobal" max-width="40%">
      <v-card> 
        <v-card-title>Marcas</v-card-title>
        <v-card-text class="pa-8">
          <v-row>
            <v-col cols="8"> 
              <v-text-field dense outlined label="Marca" v-model="newBrand" />
            </v-col>
            <v-col cols="4">
              <v-btn right class="btnadd" @click="addBrand">Agregar marca</v-btn>
            </v-col>
          </v-row>

          <v-row>
            <GeneralFilter :hideLimitLabel="true" :filterEndpoint="$API.itemtypes.getBrands" :search="searchBrand"
            @emptyFilter="getBrands" @filtered="setNewBrands">
              <DxDataGrid class="isScrolledByGeneralFilter grid-max-width" :show-borders="true"
              :data-source="tableBrands">
                <DxColumn data-field="brand" caption="Marca" />
                <DxColumn cell-template="template-buttons" caption="" />
                <template #template-buttons="{ data }">
                  <a href="#" @click="deleteBrand(data.data)">
                    <v-icon>mdi-delete</v-icon>
                  </a> 
                </template>
              </DxDataGrid>
            </GeneralFilter>
          </v-row>

          <v-col cols="12">
            <v-btn right class="btncontinue" @click="dialogBrand = false">Continuar</v-btn>
          </v-col>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showImageDialog" v-if="url" scrollable max-width="60%">
      <v-card style="border-radius: 20px;">
        <div style="width: auto; height: 80vh; border-radius: 20px;">
          <img :src="url" alt="product_image" style="width: auto; height: 80vh; border-radius: 20px;"/>
        </div>
      </v-card>
    </v-dialog>

    <ProductPriceListEditorDialog
      v-model="showPriceListEditor"
      :product-id="form.iditem"
      @saved="handleProductPriceListSaved"
    />

    <alerts v-if="alert.show" v-on:close_alert="closeAlert" v-on:accept_alert="acceptAlert" :properties="alert">
    </alerts>
  </div>
</template>

<script>
import ManageCategory from "@/components/Categories/ManageCategory.vue";
import GeneralFilter from "@/components/GeneralFilter";
import Block from "@/components/Block";
import Vue from "vue";
import Alerts from "@/components/Alerts";
import { quillConfig } from "../../../helpers/quillconfig";
import { mapState, mapGetters } from "vuex";
import { DxDataGrid, DxColumn, DxPaging, DxEditing } from "devextreme-vue/data-grid";
//import AccountingAssign from "../../acounting/partial/AccountingAssign.vue";
import { multipleCriteriaFilter } from "../../../helpers/object";
import AccountingItemForm from '../../acounting/partial/AccountingItemForm.vue';
import ProductPriceListEditorDialog from "@/components/inventory/ProductPriceListEditorDialog.vue";

const isTruthyFlag = (value) =>
  value === true || value === 1 || value === "1" || value === "true";

export default {
  name: "EditProduct",
  components: {
    Block,
    Alerts,
    ManageCategory,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPaging,
    GeneralFilter,
    //AccountingAssign,
    AccountingItemForm,
    ProductPriceListEditorDialog,
  },
  props: ["data", "win"],
  data() {
    return {
      alert: {
        type: "success",
        show: false,
        header: "",
        body: "",
      },
      valid: false,
      families: [],
      categories: [],
      subcategories: [],
      categoriesAll: [],
      subcategoriesAll: [],
      brands: [],
      tableBrands: [],
      showBgcolorNotes: "tabs",
      quillOptions: quillConfig,
      showNotes: false,
      url: null,
      image: null,
      aditional_type: ["", "Medicamento", "Vacuna"],
      types: [],
      loading: false,
      loadingBarCode: false,
      categoryName: null,
      subName: null,
      toDelete: undefined,
      showFamCat: null,
      showCatSub: null,
      form: {
        maxdiscountpercentage: null,
        maxsalepercentage: null,
        profitpercentage: null,
        maxdiscountdecimal: 0,
        maxsaledecimal: 0,
        no_provider: false,
        isexempt: false,
        isnosujeto: false,
        isnoafecto: false,
        bloquearpropinas: false,
      },
      requiredRule: [(value) => !!value || "Required."],
      providers: [],
      dialog: false,
      dialogBrand: false,
      newBrand: "",
      showImageDialog: false,
      //WAREHOUSES
      search: {
        filter: null,
      },
      searchBrand: {
        filter: null,
      },
      warehouses: {},
      batchs: {},
      accountinggroups: {},
      selectaccountinggroup: {},
      familyName: null,
      typepack: "",
      units: [
        "Unidades",
        "Libras",
        "Kilos",
        "Galones",
        "Litros",
        "Mililitros",
        "Metros",
        "Centímetros",
      ],
      dialogProviders: false,
      dialogPriceListMargins: false,
      loadingPriceListMargins: false,
      savingPriceListMargins: false,
      searchPriceListMargins: "",
      productPriceLists: [],
      priceListMarginsSnapshot: "[]",
      savePriceListMarginsTimer: null,
      providersFiltered: [],
      isFiltered: false,
      dialogBarCode: false,
      showPriceListEditor: false,
      dialogEditBarCode: false,
      barCodes: [],
      barCodesToSave: [],
      barCodeToAdd: null,
      barCodeToEdit: null,
      previousCode: null,
      validImageSize: true,
      showItemStructure: false,
      filterProducts: '',
      dataProducts: [],
      dataProductsStructure: [],
      ishosting: JSON.parse(localStorage.getItem("user")).ishosting || 0,
      posrestaurant: JSON.parse(localStorage.getItem("user"))?.posrestaurant || 0,
      brandToDelete: null,
      accountList: [],
      isAllowTransaction: true,
      showCatalogo: false,
      editAccount: {},
      historyAccount:[],
      accounts: [
        { label: 'Cuenta de Inventario', model: 'id_inventory_account' },
        { label: 'Cuenta de Costos', model: 'id_sales_account' },
        { label: 'Cuenta de Ventas', model: 'id_taxed_sales_account' },
        { label: 'Cuenta de Ventas a Crédito (CXC)', model: 'id_accounts_receivable_payments_account' },
      ],
      propSearchReset: null,
    };
  },
  computed: {
    //comercialName() {
    //  return this.form.itemname;
    //},
    ...mapGetters(["getCatalogMH"]),
    unidades(){
      return this.getCatalogMH("UnidadMedida");
    },
    tipoItemCompraGasto() {
      return this.getCatalogMH("TipoItemCompraGasto");
    },
    filteredCategories() {
      return this.form.family
        ? this.categories.filter((category) => category.id_family == this.form.family)
        : [];
    },
    filteredSubcategories() {
      const cat = this.filteredCategories.find(
        (category) => category.id == this.form.category
      );
      if(!cat){
        return [];
      }
      return this.form.category
        ? this.subcategories.filter(
          (subcategory) => subcategory.id_cat == this.form.category
        )
        : [];
    },
    ...mapState("rolesUser", {
      rolesStatus: (state) => state.roles,
    }),
    discountPreviewHint() {
      if (!this.form.maxdiscountpercentage || !this.form.itemprice) {
        return '';
      }
      const discountAmount = (parseFloat(this.form.itemprice) * parseFloat(this.form.maxdiscountpercentage)) / 100;
      const finalPrice = parseFloat(this.form.itemprice) - discountAmount;
      return `Precio mínimo de venta ${finalPrice.toFixed(2)}`;
    },
    salePreviewHint() {
      if (!this.form.maxsalepercentage || !this.form.itemprice) {
        return '';
      }
      const markupAmount = (parseFloat(this.form.itemprice) * parseFloat(this.form.maxsalepercentage)) / 100;
      const finalPrice = parseFloat(this.form.itemprice) + markupAmount;
      return `Precio máximo de venta ${finalPrice.toFixed(2)}`;
    },
    filteredPriceLists() {
      const filter = (this.searchPriceListMargins || "").trim().toLowerCase();
      if (!filter) {
        return this.productPriceLists;
      }
      return this.productPriceLists.filter((row) => {
        const source = [
          row.PriceListName,
          this.formatPriceListRange(row),
          row.ItemOriginalPrice,
          row.ItemNewPrice,
        ]
          .filter((value) => value !== null && value !== undefined)
          .join(" ")
          .toLowerCase();
        return source.includes(filter);
      });
    },
    availablePriceLists() {
      return this.filteredPriceLists.filter((row) => !row._selectedForMargin);
    },
    selectedPriceLists() {
      return this.filteredPriceLists.filter((row) => row._selectedForMargin);
    },

  },
  watch: {
    data: {
      immediate: true,
      handler(value) {
        if (!value) {
          return;
        }


        this.form.isexempt = this.parseBooleanFlag(
          value.IsExempt !== undefined ? value.IsExempt : value.isexempt
        );
        this.form.isnosujeto = this.parseBooleanFlag(
          value.IsNoSujeto !== undefined ? value.IsNoSujeto : value.isnosujeto
        );
        this.form.isnoafecto = this.parseBooleanFlag(
          value.IsNoAfecto !== undefined ? value.IsNoAfecto : value.isnoafecto
        );
        this.form.bloquearpropinas = this.parseBooleanFlag(
          value.BloquearPropinas !== undefined ? value.BloquearPropinas : value.bloquearpropinas
        );
      },
    },
  },
  async mounted() {
    this.$store.dispatch("rolesUser/getAllRoles");
    this.search.business = JSON.parse(localStorage.getItem("user")).businessid;
    this.search.branch = JSON.parse(localStorage.getItem("user")).branch;
    this.form.iduser = JSON.parse(localStorage.getItem("user")).id;
    if (this.data) {
      Object.keys(this.data).map((el) => {
        Vue.set(
          this.form,
          el != "id_account" ? el.replace("_", "").toLowerCase() : el,

          this.data[el]
        );
      });
      this.form.profitpercentage = this.data.ProfitPercentage ?? this.form.profitpercentage;

      this.form.isexempt = this.parseBooleanFlag(
        this.data.IsExempt !== undefined ? this.data.IsExempt : this.data.isexempt
      );
      this.form.isnosujeto = this.parseBooleanFlag(
        this.data.IsNoSujeto !== undefined ? this.data.IsNoSujeto : this.data.isnosujeto
      );
      this.form.isnoafecto = this.parseBooleanFlag(
        this.data.IsNoAfecto !== undefined ? this.data.IsNoAfecto : this.data.isnoafecto
      );
      this.form.bloquearpropinas = this.parseBooleanFlag(
        this.data.BloquearPropinas !== undefined ? this.data.BloquearPropinas : this.data.bloquearpropinas
      );
      this.form.items_brand = this.data?.items_brand
      this.form.family = this.data.family || null;
      if( this.form.family ) {
        await this.getCategoriesByFamily();
      }
      
      this.form.category = this.data.category || null
      if( this.form.category ) {
        await this.getSubsByCategory();
      }
      this.form.subcategory = this.data.subcategory || null
      this.form.isglobalbranch = true;
      // Asegurar que los campos de porcentaje se inicialicen correctamente
      // Si existen los valores de porcentaje, usarlos directamente
      this.form.maxdiscountpercentage = this.data.MaxDiscountPercentage || null;
      this.form.maxsalepercentage = this.data.MaxSalePercentage || null;
      
      // Si existen los valores decimales, usarlos, sino calcularlos a partir del porcentaje
      this.form.maxdiscountdecimal = this.data.MaxDiscountDecimal || (this.data.MaxDiscountPercentage ? ((parseFloat(this.data.MaxDiscountPercentage) / 100) * parseFloat(this.data.ItemPrice)).toFixed(4) : null);
      this.form.maxsaledecimal = this.data.MaxSaleDecimal || (this.data.MaxSalePercentage ? ((parseFloat(this.data.MaxSalePercentage) / 100) * parseFloat(this.data.ItemPrice)).toFixed(4) : null);
      
      // Sincronizar los valores si existe algún dato
      if (this.form.maxdiscountpercentage) this.syncDiscountDecimal();
      if (this.form.maxsalepercentage) this.syncSaleDecimal();
      
      if (
        this.form.unitspackaging != null ||
        this.form.itemunitspackaging != undefined ||
        this.form.itemunitspackaging != ""
      ) {
        const [y, z] = this.form.unitspackaging.split(" ");
        this.typepack = z;
        this.form.unitspackaging = y;
      }
    }
    this.getAllProviders();
    this.getFamilies();
    this.getCategories();
    this.getSubs();
    await this.getBrands();
    this.loadImage();

    this.getWarehouses();
    this.firstFillBarchsAndAccountingGroups();

    this.search.ID_Item = this.form.iditem;
    this.getAllBarCodesHistory();
    
    // To open barcode from Product list for Aniimate
    console.log(this.win.meta)
    if(this.win.meta.openDialogBarCode){
      this.dialogBarCode = true;
    }

    this.getProducts()
    this.getItemsStructureByProduct()

    this.form.id_inventory_account = this.data?.id_inventory_account;
    this.form.id_sales_account = this.data?.id_sales_account;
    this.form.id_accounts_receivable_payments_account = this.data?.id_accounts_receivable_payments_account;
    this.form.id_taxed_sales_account = this.data?.id_taxed_sales_account;
    this.form.id_account = this.data?.id_account;
    this.getAllAcounts();
  },
  created() {
    this.$store.dispatch("getParam", { type: "InventoryItemType" }).then((data) => {
      this.types = data.map((param) => {
        return { text: param.ParameterName, value: param.ParameterName };
      });
    });
  },

  methods: {
    parseBooleanFlag(value) {
      return value === true || value === 1 || value === "1" || value === "true";
    },
    formatMoney(value) {
      return parseFloat(value || 0).toFixed(4);
    },
    normalizeMarginInput(value) {
      if (value === "" || value === null || value === undefined) {
        return null;
      }
      const parsed = parseFloat(value);
      return Number.isNaN(parsed) ? null : parsed;
    },
    formatPriceListRange(row) {
      if (row.InitialRange == null && row.FinalRange == null) {
        return "Defecto";
      }
      return `${row.InitialRange || 0} - ${row.FinalRange || 0}`;
    },
    async openPriceListMarginsDialog() {
      this.dialogPriceListMargins = true;
      await this.loadProductPriceLists();
    },
    async loadProductPriceLists() {
      this.loadingPriceListMargins = true;
      try {
        const response = await this.$API.products.getProductPriceListMargins(this.form.iditem);
        this.productPriceLists = response.map((row) => ({
          ...row,
          ProfitMarginPercentage: this.normalizeMarginInput(row.ProfitMarginPercentage),
          _selectedForMargin: row.ProfitMarginPercentage !== null && row.ProfitMarginPercentage !== undefined && row.ProfitMarginPercentage !== "",
        }));
        this.markPriceListMarginsSnapshot();
      } catch (error) {
        console.log(error);
        this.showAlert("warning", "Advertencia", "No se pudo cargar la información de listas de precios del producto.");
      } finally {
        this.loadingPriceListMargins = false;
      }
    },
    buildSelectedPriceListMarginsPayload() {
      return this.productPriceLists
        .filter((row) => row._selectedForMargin)
        .map((row) => ({
          PriceListRowId: row.PriceListRowId,
          PriceListName: row.PriceListName,
          ID_Item: row.ID_Item,
          InitialRange: row.InitialRange,
          FinalRange: row.FinalRange,
          ProfitMarginPercentage: row.ProfitMarginPercentage,
          IsGlobalBranch: row.IsGlobalBranch,
          ID_Branch: row.ID_Branch,
          ID_Business: row.ID_Business,
        }));
    },
    serializePriceListMarginsPayload() {
      return JSON.stringify(
        this.buildSelectedPriceListMarginsPayload()
          .map((row) => ({
            ...row,
            ProfitMarginPercentage: this.normalizeMarginInput(row.ProfitMarginPercentage),
          }))
          .sort((a, b) => {
            const left = `${a.PriceListName || ""}-${a.PriceListRowId || ""}-${a.InitialRange ?? ""}-${a.FinalRange ?? ""}`;
            const right = `${b.PriceListName || ""}-${b.PriceListRowId || ""}-${b.InitialRange ?? ""}-${b.FinalRange ?? ""}`;
            return left.localeCompare(right);
          })
      );
    },
    markPriceListMarginsSnapshot() {
      this.priceListMarginsSnapshot = this.serializePriceListMarginsPayload();
    },
    hasPriceListMarginsChanges() {
      return this.serializePriceListMarginsPayload() !== this.priceListMarginsSnapshot;
    },
    queuePersistPriceListMargins() {
      clearTimeout(this.savePriceListMarginsTimer);
      this.savePriceListMarginsTimer = setTimeout(() => {
        this.persistPriceListMargins(true);
      }, 500);
    },
    addPriceListMargin(row) {
      row._selectedForMargin = true;
      if (row.ProfitMarginPercentage === null || row.ProfitMarginPercentage === undefined) {
        row.ProfitMarginPercentage = this.normalizeMarginInput(this.form.profitpercentage);
      }
      this.persistPriceListMargins(true);
    },
    removePriceListMargin(row) {
      row._selectedForMargin = false;
      row.ProfitMarginPercentage = null;
      this.persistPriceListMargins(true);
    },
    onPriceListMarginInput(row, value) {
      row.ProfitMarginPercentage = this.normalizeMarginInput(value);
      row._selectedForMargin = true;
      this.queuePersistPriceListMargins();
    },
    async persistPriceListMargins(silent = false, forceReload = false) {
      clearTimeout(this.savePriceListMarginsTimer);
      if (!this.hasPriceListMarginsChanges()) {
        return;
      }
      this.savingPriceListMargins = true;
      try {
        await this.$API.products.updateProductPriceListMargins(this.form.iditem, {
          rows: this.buildSelectedPriceListMarginsPayload(),
        });
        if (forceReload) {
          await this.loadProductPriceLists();
        } else {
          this.markPriceListMarginsSnapshot();
        }
        if (!silent) {
          this.showAlert("success", "Éxito", "Los márgenes por lista de precios fueron actualizados.");
        }
      } catch (error) {
        console.log(error);
        if (!silent) {
          this.showAlert("warning", "Advertencia", "No se pudieron actualizar los márgenes por lista de precios.");
        }
        await this.loadProductPriceLists();
      } finally {
        this.savingPriceListMargins = false;
      }
    },
    setEditCatalog(name){
      if (this.editAccount?.name === name) {
        this.showCatalogo = true;
        return;
      }
      this.propSearchReset = '';
      this.showCatalogo = true;
      this.$nextTick(() => {
        this.propSearchReset = null;
      });
      this.editAccount = {
          name: name, 
          old: this.form[name], 
          new: 0
        }; 
    },
    deleteBrand(data) {
      this.dialogBrand = false
      this.brandToDelete = data

      this.showAlert(
        "question",
        "Eliminar",
        "¿Está seguro de eliminar la marca? Los productos registrados con esta marca se verán afectados.",
        "deletebrand"
      );
    },
    accountChanged( e ) {
      this.form.id_account = e
    },
    handleClickImage() {
      if(this.url && this.url.length) {
        this.showImageDialog = true;
      }
      else {
        this.showAlert("warning", "Advertencia", "El producto no cuenta con imagen disponible.");
      }
    },
    handleTaxFlagChange(flag) {
      if (flag === "isexempt" && this.form.isexempt) {
        this.form.isnosujeto = false;
        this.form.isnoafecto = false;
      } else if (flag === "isnosujeto" && this.form.isnosujeto) {
        this.form.isexempt = false;
        this.form.isnoafecto = false;
      } else if (flag === "isnoafecto" && this.form.isnoafecto) {
        this.form.isexempt = false;
        this.form.isnosujeto = false;
      }
    },
    checkPrincipalBarCode(data) {
      this.dialogBarCode = false
      if(data.PrincipalBarCode) {
        this.$API.inventoryitemsbarcodes.updatePrincipalBarCode({
          status: data.PrincipalBarCode,
          BarCode: data.BarCode,
          ID_Item: this.data.ID_Item
        }).then(response => {
          this.barCodes.forEach((item, index) => {
            if (item.BarCode != data.BarCode) {
              this.barCodes[index].PrincipalBarCode = false;
            }
          })
          this.showAlert("success", "Éxito", response.message);
        })
        .catch(() => {
          this.showAlert("warning", "Advertencia", "Ocurrio un problema al intentar actualizar el código de barra / código alterno.");
        })
      }
      else {
        this.$API.inventoryitemsbarcodes.updatePrincipalBarCode({
          status: data.PrincipalBarCode,
          BarCode: data.BarCode,
          ID_Item: this.data.ID_Item
        }).then(response => {
          this.showAlert("success", "Éxito", response.message);
        })
        .catch(() => {
          this.showAlert("warning", "Advertencia", "Ocurrio un problema al intentar actualizar el código de barra / código alterno.");
        })
      }
    },
    async loadImage() {
      if (this.data.ItemImagePath){
      //const { imageBase64: profileimagetoassign } = await this.$API.utilities.getImageInBase64({ "file": this.data.ItemImagePath }); 
      this.url = this.data.ItemImagePath;
      }
    },
    fillItemComercialName() {
      this.form.itemcomercialname = this.form.itemname
    },
    getAllBarCodesHistory() {
      this.$API.inventoryitemsbarcodes
        .getAllBarCodesHistory(this.form.iditem)
        .then((data) => {
          this.barCodes = data;
        })
        .catch((error) => console.log(error));
    },
    reloadCategories() {
      this.getFamilies();
      this.getCategories();
      this.getSubs();
    },
    checkDuplicate(NewBarCode) {
      return !this.barCodes.find(({ BarCode }) => NewBarCode === BarCode);
    },
    addBarCode() {
      this.loadingBarCode = true;
      if (this.checkDuplicate(this.barCodeToAdd)) {
        const newBarCode = {
          BarCode: this.barCodeToAdd,
          ID_Branch: this.form.idbranch,
          ID_Business: this.form.idbusiness,
          ID_Item: this.form.iditem,
        };

        this.$API.inventoryitemsbarcodes
          .saveBarCode(newBarCode)
          .then((response) => {
            if (!response.success) {
              this.dialogBarCode = false;
              this.showAlert("warning", "Advertencia", response.message, "showBackBarcodes");
              this.dialogBarCode = false;
            }
            if(response.success){
              this.dialogBarCode = false;
              this.showAlert("success", "Éxito", response.message, "showBackBarcodes");
            }
            this.getAllBarCodesHistory();
          })
          .catch((error) => console.log(error))
          .finally(() =>  {
            this.loadingBarCode = false
            this.barCodeToAdd = null
          })
      } else {
        this.dialogBarCode = false;
        this.loadingBarCode = false
        this.barCodeToAdd = null
        this.showAlert("warning", "Advertencia", "No debe repetir códigos de barra / código alterno", "showBackBarcodes");
      }
    },
    editShowBarCode(data) {
      this.dialogEditBarCode = true;
      this.previousCode = data.BarCode;
      this.barCodeToEdit = this.previousCode;
    },
    editBarCode() {
      this.loadingBarCode = true;
      this.dialogEditBarCode = false;
      if (this.checkDuplicate(this.barCodeToEdit)) {
        const editBarCode = this.barCodes.find(
          (item) => item.BarCode === this.previousCode
        );
        editBarCode.BarCode = this.barCodeToEdit;

        this.$API.inventoryitemsbarcodes
          .updateBarCode(editBarCode)
          .then((response) => {
            if (!response.success) {
              this.dialogBarCode = false;
              this.showAlert("warning", "Advertencia", response.message, "showBackBarcodes");
            }
            
            if(response.success){
              this.dialogBarCode = false;
              this.showAlert("success", "Éxito", response.message, "showBackBarcodes");
            }
            this.getAllBarCodesHistory()
          })
          .catch((error) => console.log(error))
          .finally(() => {
            this.loadingBarCode = false;
            this.dialogEditBarCode = false;
          });
      } else {
        this.dialogBarCode = false;
        this.loadingBarCode = false
        this.showAlert("warning", "Advertencia", "No debe repetir códigos de barra / código alterno", "showBackBarcodes");
      }
    },
    deleteBarCode(data) {
      this.loadingBarCode = true;
      this.$API.inventoryitemsbarcodes
        .deleteBarCode(data)
        .then((response) => {
          if(!response.success){
              this.dialogBarCode = false;
              this.showAlert("warning", "Advertencia", response.message, "showBackBarcodes");
          }

          if(response.success){
              const index = this.barCodes.indexOf(data);
              if (index > -1) {
                this.barCodes.splice(index, 1);
              }
              this.dialogBarCode = false;
              this.showAlert("success", "Éxito", response.message, "showBackBarcodes");
          } 
        })
        .catch((error) => console.log(error))
        .finally(() => {
          this.loadingBarCode = false;
        })
    },
    clearFilter() {
      this.isFiltered = false;
    },
    filterHandler(response) {
      console.log("filter handler ", response);
      this.isFiltered = true;
      this.providersFiltered = response;
    },
    filterPromise(filterObj) {
      const filterArray = [
        "ProviderName",
        "ProviderPhone",
        "ProviderEmail",
        "ProviderAddress",
      ];
      return new Promise((resolve, reject) => {
        try {
          resolve(multipleCriteriaFilter(filterArray, filterObj, this.providers));
        } catch (error) {
          reject(error);
        }
      });
    },

    getFamilies() {
      this.$API.itemtypes.getFamilies().then((response) => {
        this.families = response;
      });
    },
    getCategories() {
      this.$API.itemtypes.getCategories().then((response) => {
        this.categories = response;
        this.categoriesAll = response;
      });
    },
    async getCategoriesByFamily() {
      this.categories = this.categoriesAll.filter(element => element.id_family === this.form.family );
    },
    getSubs() {
      this.$API.itemtypes.getSubs().then((response) => {
        this.subcategories = response;
        this.subcategoriesAll = response;
      });
    },
    async getSubsByCategory() {
      this.subcategories = this.subcategoriesAll.filter(element => element.id_cat === this.form.category );
    },
    async getBrands() {
      this.brands = await this.$API.itemtypes.getBrands( { id_brand: this.form.items_brand } )
      this.tableBrands = this.brands
    },
    async addBrand() {
      this.loading = true
      this.dialogBrand = false
      this.$API.itemtypes.addBrand({ brand: this.newBrand})
        .then(async () => {
          await this.getBrands()
          this.showAlert("success", "Exito", "Se ha registrado la nueva marca.")          
          this.loading = false
        })
        .catch(() => {
          this.showAlert("warning", "Advertencia", "Ocurrio un problema registrando la nueva marca.")
          this.loading = false
        })
    },
    async closeAlert() {
      this.alert.show = false;

      if (this.alert.options == "deleteproduct") {
        this.$store.dispatch("deleteWindowByUuid", { uuid: this.win.uuid });
        this.$store.dispatch("reloadData", "products");
      }

      if (this.alert.options == "deletebrand") {
        this.brandToDelete = null
      }

      if (this.alert.options == 'showBackBarcodes') {
        this.dialogBarCode = true;
      }
    },
    openPriceListEditor() {
      if (!this.form.iditem) {
        this.showAlert("warning", "Advertencia", "No se encontró el producto para editar su lista de precios.");
        return;
      }

      this.showPriceListEditor = true;
    },
    handleProductPriceListSaved() {
      this.showAlert("success", "Éxito", "La lista de precios del producto fue actualizada.");
    },
    acceptAlert() {
      this.alert.show = false;

      if (this.alert.options == "deleteproduct") {
        this.deleteProducts();
      }

      if (this.alert.options == "deletebrand") {
        this.loading = true
        this.$API.itemtypes.deleteBrand({ id: this.brandToDelete.id })
          .then(async () => {
            await this.getBrands()
            this.brandToDelete = null
            this.showAlert("success", "Exito", "La marca seleccionada ha sido eliminada.")
            this.loading = false
          })
          .catch(() => {
            this.brandToDelete = null
            this.showAlert("warning", "Advertencia", "Ocurrio un problema eliinado la marca seleccionada, por favor intente de nuevo.")
            this.loading = false
          })
      }
    },
    showAlert(type, header, body, options = null) {
      type = type == null ? "danger" : type;
      this.alert.type = type;
      this.alert.header = header;
      this.alert.body = body;
      this.alert.show = true;
      this.alert.options = options != null ? options : null;
    },

    confirmdeleteProduct() {
      console.log(this.form);
      let message = "¿Seguro que desea eliminar el producto seleccionado?";
      if (this.form.stock > 0) {
        message = `El producto tiene ${this.form.stock} existencias, ¿Seguro que desea eliminar el producto seleccionado?`
      }else if (this.form.warehouse || this.form.warehousename  ) {
        message = "El esta asociado a un almacen/bodega, ¿Seguro que desea eliminar el producto seleccionado?"
      }
      this.showAlert(
        "question",
        "Eliminar",
        message,
        "deleteproduct"
      );
    },
    Preview_image() {
      this.url = URL.createObjectURL(this.image);
    },
    getAllProviders() {
      this.$API.providers.getProviders(this.search).then((response) => {
        this.providers = response;
        this.$API.providers
          .getCheckedProvidersOfProduct({ iditem: this.form.iditem })
          .then((response2) => {
            response2.forEach((item2) => {
              const index = response.findIndex(
                (item1) => item1.ID_Provider === item2.ID_Provider
              );
              if (index !== -1) {
                this.providers[index] = item2;
              }
            });

            this.providers = this.providers.sort((a, b) => {
              if(a.Checked && !b.Checked){
                return -1;
              }else if( !a.Checked && b.Checked ){
                return 1;
              }else {
                return 0;
              }
            })
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    updateProducts() {
      if (this.checkImageSize()) return;

      if (!this.valid) {
        this.showAlert("warning", "Advertencia", "Faltan campos por llenar");
        return;
      }

      const validProviders = this.providers.some((provider) => provider.Checked);
      const noProvider = isTruthyFlag(
        JSON.parse(localStorage.getItem("user"))?.nomergeprodwithprovs
      );
      if (!validProviders && !this.form.no_provider && !noProvider) {
        this.showAlert(
          "warning",
          "Advertencia",
          "El producto debe estar asociado con al menos un proveedor"
        );
        return;
      }

      if (this.form.unitspackaging) {
        this.form.unitspackaging = this.form.unitspackaging + " " + this.typepack;
      }
      //this.form.itemcomercialname = this.comercialName;
      this.loading = true;
      const formdata = new FormData();
      formdata.append("file", this.image);
      formdata.append("product", JSON.stringify(this.form));

      var providersForProduct = this.providers.filter(
        (item) => item.Checked === true || item.Checked === 1
      );
      formdata.append("providers", JSON.stringify(providersForProduct));

      this.$API.products
        .updateProduct(this.form.iditem, formdata)
        .then(() => {
          this.loading = false;
          this.showAlert("success", "Exito", "Producto actualizado");
          this.$store.dispatch("reloadData", "products");
        })
        .catch(() => {
          this.loading = false;
        });
    },
    deleteProducts() {
      this.loading = true;
      this.$API.products
        .logicalDeleteProduct(this.form.iditem)
        .then((res) => {
          console.log(res);
          this.loading = false;
          this.showAlert("success", "Exito", "Producto eliminado", "deleteproduct");
          //this.$emit('reloadData', 'delete');
        })
        .catch(() => {
          this.loading = false;
          this.showAlert("danger", "Error", "No se pudo eliminar el producto");
        });
    },
    onEditorChange(e) {
      this.form.itemnote = e.html;
      if (this.form.itemnote != "") {
        this.showBgcolorNotes = "tabsContent";
      } else if (this.form.itemnote == "" || this.form.itemnote == "<p><br></p>") {
        this.showBgcolorNotes = "tabs";
      } else {
        this.showBgcolorNotes = "tabs";
      }
    },

    getWarehouses() {
      this.$API.warehouse.getWarehouses(this.search).then((response) => {
        this.warehouses = response;
      });
    },

    firstFillBarchsAndAccountingGroups() {
      let warehouse = this.form.warehouse;
      this.search.warehouse = warehouse;
      this.$API.warehouse
        .getBatchs(this.search)
        .then((response) => {
          this.batchs = response;
        })
        .catch(() => {
          this.batchs = {};
        });

      this.$API.warehouse
        .getAccountingGroups(this.search)
        .then((response) => {
          this.accountinggroups = response;
          this.selectaccountinggroup = this.accountinggroups.find(
            (i) => i.ID_AccountingLine == this.form.idaccountingline
          );
        })
        .catch(() => {
          this.accountinggroups = {};
        });
    },

    fillBatchsAndAccountingGroups() {
      let warehouse = this.form.warehouse;
      this.search.warehouse = warehouse;
      this.$API.warehouse
        .getBatchs(this.search)
        .then((response) => {
          this.batchs = response;
        })
        .catch(() => {
          this.batchs = {};
        });

      this.$API.warehouse
        .getAccountingGroups(this.search)
        .then((response) => {
          this.accountinggroups = response;
        })
        .catch(() => {
          this.accountinggroups = {};
        });
    },

    setValInForm() {
      this.form.idaccountingline = this.selectaccountinggroup.ID_AccountingLine;
      this.form.idaccountingcategory = this.selectaccountinggroup.ID_AccountingCategory;
      this.form.idaccountingsubcategory = this.selectaccountinggroup.ID_AccountingSubCategory;
    },
    removeSon(){
      console.log("remove son")
      this.form.category = null;
      this.form.subcategory = null;
    },

    filterHandlerFamilies(response) {
      this.families = response;
    },

    filterHandlerCategories(response) {
      this.categories = response;
    },

    filterHandlerSubs(response) {
      this.subcategories = response;
    },

    filterHandlerBarCodes(response) {
      console.log(response);
      this.barCodes = response;
    },
    setNewBrands(response) {
      this.tableBrands = response
    },
    maxFileSize(event) {
      const allowedSize = 2 * 1024 * 1024; // 2 MB in bytes
      const fileSize = event.size;

      if (fileSize > allowedSize) {
        this.validImageSize = false;
        return `El tamaño del archivo debe ser menor a 2 Mb`;
      }

      this.validImageSize = true;
      return true;
    },
    checkImageSize() {
      if (this.validImageSize == false) {
        this.showAlert("danger", "Error", "El tamaño de la imagen debe ser menor a 2 Mb");
        return true;
      }
      return false;
    },
    async getProducts() {
      await this.$API.products.newGetProducts({ filter: this.filterProducts })
      .then(response => {
        this.dataProducts = response
      })
    },
    filterHandlerProducts(response) {
      this.dataProducts = response
    },
    addProductToStructure(data) {
      if (!this.dataProductsStructure.find(item => item.ID_Item_Base == data.ID_Item)) {
        let item = {
          ID_Item: this.form.iditem,
          ID_Item_Base: data.ID_Item,
          QuantityBase: 0,
          UnitBase: data.ItemMeasureUnit,
          ID_Business: this.form.idbusiness,
          ID_Branch: this.form.idbranch,
          ItemName: data.ItemName,
          ItemComercialName: data.ItemComercialName
        }

        this.dataProductsStructure.push(item)
      }
    },
    getItemsStructureByProduct() {
      this.$API.products.getItemsStructureByProduct({ ID_Item: this.form.iditem })
        .then(response => {
          this.dataProductsStructure = response
        })
    },
    saveStructureOfProduct() {
      if(this.dataProductsStructure.length == 0) {
        this.$API.products.saveStructureOfProduct({ "deleteAll": 1, "ID_Business": this.form.idbusiness, "ID_Branch": this.form.idbranch, "ID_Item": this.form.iditem})
        .then(response => {
          this.showItemStructure = false
          if (response?.status == "OK") {
            this.showAlert("success", "Éxito", "La información del producto se ha guardado satisfactoriamente.");
          }
          else if (response?.status == "ERROR") {
            this.showAlert("danger", "Error", "Hubo un problema en guardar la información, por favor intentelo nuevamente.");
          }
          else {
            this.showAlert("danger", "Error", "Hubo un problema en guardar la información, por favor intentelo nuevamente o contáctese con el administrador del sistema.");
          }
        }) .catch(() => {
          this.showItemStructure = false
          this.showAlert("danger", "Error", "Hubo un problema en guardar la información, por favor intentelo nuevamente o contáctese con el administrador del sistema.");
        })
      }
      else {
        this.$API.products.saveStructureOfProduct(this.dataProductsStructure)
          .then(response => {
            this.showItemStructure = false
            if (response?.status == "OK") {
              this.showAlert("success", "Éxito", "La información del producto se ha guardado satisfactoriamente.");
            }
            else if (response?.status == "ERROR") {
              this.showAlert("danger", "Error", "Hubo un problema en guardar la información, por favor intentelo nuevamente.");
            }
            else {
              this.showAlert("danger", "Error", "Hubo un problema en guardar la información, por favor intentelo nuevamente o contáctese con el administrador del sistema.");
            }
          }) .catch(() => {
            this.showItemStructure = false
            this.showAlert("danger", "Error", "Hubo un problema en guardar la información, por favor intentelo nuevamente o contáctese con el administrador del sistema.");
          })
      }
    },
    getAccountDetail(id_account){      
      if (!id_account) 
        return 'Sin asignar';
      const account = this.accountList.filter((item) => item.id_account == id_account);
      if (!account || account.length == 0) {
        return 'Sin asignar';
      }
      return account[0]?.account_code + ' ' + account[0]?.account_description;
    },
    getAllAcounts() {
      try {
        this.$API.branchaccountcatalog
          .getActiveBranchAccountCatalog()
          .then(({ data }) => {
            this.accountList = data;
          });
      } catch (error) {
        console.log(error);
      }
    },
    setAccountingSelected(account){
      this.editAccount.new = account.id_account;
      this.form[this.editAccount.name] = this.editAccount.new;
      this.historyAccount[this.editAccount.name] = this.editAccount;
      this.showCatalogo = false;
    },
    delProductOfStructure(data) {
      this.dataProductsStructure = this.dataProductsStructure.filter(item => item.ID_Item_Base !== data.ID_Item_Base)
    },
    syncDiscountDecimal() {
      if (!this.form.maxdiscountpercentage) {
          this.form.maxdiscountdecimal = null;
          return;
      }
      let percent = parseFloat(this.form.maxdiscountpercentage || 0);
      if (percent < 0) this.form.maxdiscountpercentage = 0;
      if (percent > 100) this.form.maxdiscountpercentage = 100;
      this.form.maxdiscountdecimal = ((parseFloat(this.form.maxdiscountpercentage || 0) / 100) * parseFloat(this.form.itemprice)).toFixed(4);
    },
    syncSaleDecimal() {
      if (!this.form.maxsalepercentage) {
          this.form.maxsaledecimal = null;
          return;
      }
      let percent = parseFloat(this.form.maxsalepercentage || 0);
      if (percent < 0) this.form.maxsalepercentage = 0;
      if (percent > 100) this.form.maxsalepercentage = 100;
      this.form.maxsaledecimal = ((parseFloat(this.form.maxsalepercentage || 0) / 100) * parseFloat(this.form.itemprice)).toFixed(4);
    }
  },
};
</script>

<style scoped>
::v-deep .ndfHFb-c4YZDc-Wrql6b {
  display: none;
}

.btnsave {
  background-color: #00A178 !important;
  color: white;
}

.btnadd {
  background-color: #3498DB !important;
  color: white;
}

.btndelete {
  background-color: #e3191e !important;
  color: white;
}

.tabs:hover {
  background-color: rgba(80, 80, 80, 1);
  cursor: pointer;
}

.tabsContent:hover {
  background-color: #ffb266;
  cursor: pointer;
}

.tabs {
  width: 100%;
  padding: 10px;
  background-color: rgba(60, 60, 60, 1);
  color: white !important;
  border-style: solid;
  border-color: black;
  border-width: 1px;
  border-radius: 10px;
}

.tabsNh {
  width: 100%;
  padding: 10px;
  background-color: rgba(60, 60, 60, 1);
  color: white !important;
  border-style: solid;
  border-color: black;
  border-width: 1px;
  border-radius: 10px;
}

.tabsContent {
  width: 100%;
  padding: 10px;
  background-color: #f29d35;
  color: white !important;
  border-style: solid;
  border-color: black;
  border-width: 1px;
  border-radius: 10px;
}

.btncontinue {
  background-color: rgba(80, 80, 80, 1) !important;
  color: white;
}

.grid-max-width {
  min-width: 100px !important;
}

.barcode-dialog {
  z-index: 100 !important;
}

.barcode-edit-dialog {
  z-index: 200 !important;
}

.alert-dialog {
  z-index: 300 !important;
}

.product-action-row {
  margin-top: -62px;
}

.price-list-margins-dialog {
  display: flex;
  flex-direction: column;
  max-height: 86vh;
}

.price-list-margins-content {
  overflow-y: auto;
  padding-bottom: 8px;
}

.price-list-margins-toolbar {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
}

.price-list-margins-search {
  min-width: 0;
}

.price-list-margins-section {
  width: 100%;
}

.price-list-margins-hint {
  display: block;
  width: 100%;
  text-align: right;
  line-height: 1.3;
  white-space: normal;
}

.margin-editor {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  min-height: 38px;
  padding: 0 12px;
  border: 1px solid #cfd8dc;
  border-radius: 4px;
  background: #fff;
}

.margin-editor__input {
  width: 100%;
  border: 0;
  outline: 0;
  background: transparent;
  font-size: 14px;
  color: #2c3e50;
}

.margin-editor__input::-webkit-outer-spin-button,
.margin-editor__input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.margin-editor__input[type=number] {
  -moz-appearance: textfield;
}

.margin-editor__suffix {
  color: #607d8b;
  font-weight: 600;
}

::v-deep .price-list-margins-grid .dx-datagrid-pager {
  padding-top: 8px;
}

@media (max-width: 960px) {
  .product-action-row {
    margin-top: 0;
  }

  .price-list-margins-toolbar {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .price-list-margins-hint {
    text-align: left;
  }
}

.note-size{
  font-size: 14px;
}
</style>
